import React from 'react';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';

export default class RemoveAssignmentsOrderSummary extends React.Component {
    getTitle = () => {
        const { job } = this.props;

        return [job.name, job.foremanName, job.workOrderNumber]
            .filter(Boolean)
            .join(' ');
    };

    render() {
        const { job, day } = this.props;

        return (
            <div>
                As a reminder, you are looking at assignments for the{' '}
                <strong>
                    {job.name} {job.foremanName} {job.workOrderNumber}
                </strong>{' '}
                order. This order is for{' '}
                <strong>
                    {moment(day).format(MomentDateFormat.WeekDayNameAndDate)}
                    {job.startTime && <span> at {job.startTime}</span>}
                </strong>
                .
            </div>
        );
    }
}
